<div class="container isg-confirmation-input-dlg">
  <form class="k-form" [formGroup]="formGroup">
    <kendo-formfield>
      <label class="isg-confirmation-label" for="content">{{content}}</label>
      <input id="content" formControlName="content" kendoTextBox #contentInput />
      <kendo-formerror>Error: value is required</kendo-formerror>
    </kendo-formfield>
  </form>
  <kendo-dialog-actions>
    <button kendoButton (click)="onOk()" themeColor="primary" [disabled]="!formGroup.valid">Ok</button>
    <button kendoButton (click)="onCancel($event)">Cancel</button>    
  </kendo-dialog-actions>
</div>
